import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import IndexPage from '../pages/IndexPage';
import DemoPage from '../pages/DemoPage';
import IdeaPage from '../pages/IdeaPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
      <Route path="/idea/:id" element={<IdeaPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;


